.wrapper {
  display: inline-flex;
  flex: 0 0 auto;
  width: 1.25em;
  height: 1.25em;
  min-width: 1.25em;
  min-height: 1.25em;
  aspect-ratio: 1;
  margin: 0;
  line-height: 1;
  vertical-align: middle;
}

.spinner {
  display: block;
  width: 100%;
  height: 100%;
  transform-origin: center;
}

.arc {
  fill: none;
  stroke-width: 2.5;
}

.arc {
  stroke: currentColor;
  stroke-linecap: round;
  stroke-dasharray: 30 57;
}

.wrapper[data-visible="true"] .spinner {
  animation: spinner-rotate 0.8s linear infinite;
}

@keyframes spinner-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .wrapper[data-visible="true"] .spinner {
    animation-duration: 1.6s;
  }
}
